import { getStores } from 'components/StoreInfo/selector';
import { closeMainMenu } from 'components/MainMenu/actions';
import styles from '../styles.scss';
import { StoresNavigationBlock } from 'models/StoresNavigationBlock';
import { NavigationRoot } from 'models/NavigationRoot';
import { rm } from 'utils';
import { useNavigation, Header, Item, SlidingItem } from 'components/Navigation';
import { useSelector, useDispatch } from 'react-redux';
import { selectBlackFridayStatus } from 'components/Header/themes/BGH/selector';
import cn from 'classnames';

type MergedProps = Pick<StoresNavigationBlock, 'header'>;

const StoresList = ({ header }: MergedProps) => {
  const stores = useSelector(getStores);
  const dispatch = useDispatch();
  const dispatchCloseMainMenu = () => dispatch(closeMainMenu());
  const blackFridayIsActive = useSelector(selectBlackFridayStatus);

  return (
    <Item className={cn({ [styles.blackFriday]: blackFridayIsActive })}>
      <Header invert>{header}</Header>
      {stores.map(store => (
        <Item key={store.url}>
          <a href={store.url} onClick={dispatchCloseMainMenu}>
            <Header>
              <span className={styles.store}>
                <span>{store.location}</span>
                <span>{rm('stores_info_opening_hours_today', store.todaysOpeningHours)}</span>
              </span>
            </Header>
          </a>
        </Item>
      ))}
    </Item>
  );
};

export const StoresBlock = ({ header, items }: StoresNavigationBlock) => {
  const { openLevel } = useNavigation();
  const open = (item: NavigationRoot) => () =>
    void openLevel(<StoresList key={item.title} header={item.title} />);
  return (
    <Item>
      <Header invert>{header}</Header>
      {items.map(item => (
        <SlidingItem key={item.title} title={item.title} onClick={open(item)} />
      ))}
    </Item>
  );
};
